export class ContactFonction {
  public id: number;
  public fonction?: string;
  public contactID?: number;
  public flagDelete?: number;
  public __CREATED_BY_USERID?: number;
  public __CREATED_ON?: string; // ($date-time)
  public __MODIFIED_BY_USERID?: number;
  public __MODIFIED_ON?: string; // ($date - time)
  public __DELETED_BY_USERID?: number;
  public __DELETED_ON?: string; // ($date - time)
}
